module.exports = __webpack_public_path__ + "assets/img/xygl__d_2.700f5c0b.png";